<template>
  <el-scrollbar
    ref="scrollContainerRef"
    :vertical="false"
    class="scroll-container"
    @wheel.prevent="handleScroll"
  >
    <slot />
  </el-scrollbar>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, toRefs, computed, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
export default defineComponent({
  emits: ['scroll'],
  setup(_, context) {
    const scrollContainerRef = ref()
    const scrollWrapper = computed(() => {
      const container = scrollContainerRef.value as any
      if (!container) return null
      return (container.wrapRef || container.$refs?.wrap$ || container.$el?.querySelector?.('.el-scrollbar__wrap')) as HTMLElement | null
    })
    const { ctx } = getCurrentInstance() as any
    const tagSpacing = 4

    const state = reactive({
      handleScroll: (e: WheelEvent) => {
        const eventDelta = (e as any).wheelDelta || -e.deltaY * 40
        const wrapper = scrollWrapper.value
        if (wrapper) {
          wrapper.scrollLeft = wrapper.scrollLeft + eventDelta / 4
        }
      },
      moveToCurrentTag: (currentTag: HTMLElement) => {
        const container = (scrollContainerRef.value as any)?.$el as HTMLElement | undefined
        if (!container) return
        const containerWidth = container.offsetWidth
        const tagList = (ctx?.$parent?.$refs?.tag || []) as any[]
        if (!tagList || !Array.isArray(tagList) || tagList.length === 0) return

        let fristTag = tagList[0]
        let lastTag = tagList[tagList.length - 1]
        const wrapper = scrollWrapper.value
        if (!wrapper) return

        if (fristTag === currentTag) {
          wrapper.scrollLeft = 0
        } else if (lastTag === currentTag) {
          wrapper.scrollLeft = Math.max(0, wrapper.scrollWidth - containerWidth)
        } else {
          // find preTag and nextTag
          const currentIndex = tagList.findIndex(item => item === currentTag)
          if (currentIndex < 0) return

          const prevTag = tagList[currentIndex - 1]
          const nextTag = tagList[currentIndex + 1]
          if (!prevTag || !nextTag) return

          const nextEl = nextTag.$el || nextTag
          const prevEl = prevTag.$el || prevTag
          if (!nextEl || !prevEl) return

          // the tag's offsetLeft after of nextTag
          const afterNextTagOffsetLeft = (nextEl.offsetLeft || 0) + (nextEl.offsetWidth || 0) + tagSpacing
          // the tag's offsetLeft before of prevTag
          const beforePrevTagOffsetLeft = (prevEl.offsetLeft || 0) - tagSpacing

          if (afterNextTagOffsetLeft > wrapper.scrollLeft + containerWidth) {
            wrapper.scrollLeft = afterNextTagOffsetLeft - containerWidth
          } else if (beforePrevTagOffsetLeft < wrapper.scrollLeft) {
            wrapper.scrollLeft = beforePrevTagOffsetLeft
          }
        }
      }
    })

    const emitScroll = () => {
      context.emit('scroll')
    }

    onMounted(() => {
      if (scrollWrapper.value) {
        scrollWrapper.value.addEventListener('scroll', emitScroll, true)
      }
    })

    onBeforeUnmount(() => {
      if (scrollWrapper.value) {
        scrollWrapper.value.removeEventListener('scroll', emitScroll)
      }
    })

    return {
      scrollContainerRef,
      ...toRefs(state)
    }
  }

})
</script>

<style lang="scss" scoped>

.scroll-container {
  .el-scrollbar__bar {
    bottom: 0px;
  }

  .el-scrollbar__wrap {
    height: 49px;
  }
}
</style>

<style lang="scss" scoped>
.scroll-container {
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  width: 100%;
}
</style>
